var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('b-skeleton'):_c('prd-multiselect',{attrs:{"placeholder":_vm.placeholder,"custom-label":_vm.customLabel,"options":_vm.options,"reset-after":_vm.resetAfter,"html":""},on:{"select":_vm.optionSelected}})}
var staticRenderFns = []

export { render, staticRenderFns }